import React from "react";
import { JobDocumentTypeEnum, jobDocumentTypeToText } from "../../../job-page/job-document/job-document.types";
import { useTemplatesStore } from "../../../../store/Templates/templates.store";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../../../../components/ui/select";

interface ActionConfiguratorProps {
	ruleId: string;
	documentType: JobDocumentTypeEnum.Quotation | JobDocumentTypeEnum.DeliveryNote;
	templateId: number | null;
	onDocumentTypeChange: (
		type: JobDocumentTypeEnum.Quotation | JobDocumentTypeEnum.DeliveryNote
	) => void;
	onTemplateIdChange: (templateId: number | null) => void;
}

export const ActionConfigurator: React.FC<ActionConfiguratorProps> = ({
	ruleId,
	documentType,
	templateId,
	onDocumentTypeChange,
	onTemplateIdChange,
}) => {
	const { templatesLookup } = useTemplatesStore((state) => ({
		templatesLookup: state.templatesLookup,
	}));

	const templates = Object.values(templatesLookup).sort((a, b) =>
		(a.name || "").localeCompare(b.name || "")
	);

	return (
		<div className="space-y-3">
			{/* Document Type Selector */}
			<div className="flex gap-4">
				<label className="flex items-center gap-2 cursor-pointer">
					<input
						type="radio"
						name={`documentType-${ruleId}`}
						value={JobDocumentTypeEnum.Quotation}
						checked={documentType === JobDocumentTypeEnum.Quotation}
						onChange={() =>
							onDocumentTypeChange(JobDocumentTypeEnum.Quotation)
						}
						className="h-4 w-4"
						data-testid="document-type-kv"
						aria-label="Kostenvoranschlag"
					/>
					<span className="text-sm">
						{jobDocumentTypeToText[JobDocumentTypeEnum.Quotation]} (KV)
					</span>
				</label>
				<label className="flex items-center gap-2 cursor-pointer">
					<input
						type="radio"
						name={`documentType-${ruleId}`}
						value={JobDocumentTypeEnum.DeliveryNote}
						checked={documentType === JobDocumentTypeEnum.DeliveryNote}
						onChange={() =>
							onDocumentTypeChange(JobDocumentTypeEnum.DeliveryNote)
						}
						className="h-4 w-4"
						data-testid="document-type-ls"
						aria-label="Lieferschein"
					/>
					<span className="text-sm">
						{jobDocumentTypeToText[JobDocumentTypeEnum.DeliveryNote]} (LS)
					</span>
				</label>
			</div>

			{/* Template Selector */}
			<Select
				value={!templateId ? "none" : templateId.toString()}
				onValueChange={(value) =>
					onTemplateIdChange(value === "none" ? null : Number(value))
				}
			>
				<SelectTrigger className="w-full" aria-label="Vorlage auswählen">
					<SelectValue placeholder="Vorlage auswählen" />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value="none">
						Ohne Vorlage (leeres Dokument)
					</SelectItem>
					{templates.map((template) => (
						<SelectItem
							key={template.id}
							value={template.id.toString()}
						>
							{template.name || template.code}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};
